import { Initiative } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import {
	DateRangeQueryParams,
	KeyPaginationQueryParams,
	PaginatedResource,
	SonarSortDirection
} from '@sonar-software/sonar-ts-types';

export type GetInitiativesRequest = KeyPaginationQueryParams & DateRangeQueryParams & {
	assignedTos?: Array<number>;
	deleted?: boolean;
	sortBy?: string;
	sortDirection?: SonarSortDirection;
	statuses?: Array<string>;
	title?: string;
	types?: Array<string>;
};

export type GetInitiativesResponse = PaginatedResource<Initiative>;

export const getInitiatives = createGetEndpoint<GetInitiativesRequest, GetInitiativesResponse>(
	(request) => `/api/v3/initiatives?${getQueryString(request)}`
);
